import { message } from 'antd'
import crypto from 'crypto'

// 手机号码格式正则(严格)
export const phoneReg = /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-7|9])|(?:5[0-3|5-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1|8|9]))\d{8}$/
// 邮箱格式正则
export const mailReg = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
// 社会信用代码格式正则
export const socialRreditReg = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/
// 密码格式正则
export const passwordReg = /^\S*(?=\S{6,})(?=\S*\d)(?=\S*[A-Z])(?=\S*[a-z])(?=\S*[!@#$%^&*? ])\S*$/
// 座机格式正则
export const landlineReg = /0\d{2,3}-\d{7,8}$/
// qq号码格式正则
export const qqReg = /^[1-9][0-9]{4,10}$/
// 邮编格式正则
export const postcodeReg = /^(0[1-7]|1[0-356]|2[0-7]|3[0-6]|4[0-7]|5[1-7]|6[1-7]|7[0-5]|8[013-6])\d{4}$/

// 加密
export function hashField(field) {
  return crypto.createHash('sha1').update(String(field)).digest('hex')
}

export function exportFiles(res, fileName) {
  const blob = new Blob([res.blob])
  const elink = document.createElement('a')
  document.body.appendChild(elink)
  elink.download = fileName
  elink.style.display = 'none'
  elink.href = URL.createObjectURL(blob)
  elink.click()
  document.body.removeChild(elink)
}

// 支持预览的文件类型
export const acceptImgList = ['jpg', 'jpeg', 'png']

// 是否可以预览
export function isAcceptImg(extName) {
  return acceptImgList.indexOf(extName?.toLocaleLowerCase()) !== -1
}

/**
 * download some post request
 * copy from ifs-eui
 */
export function downloadFile(url, params) {
  return new Promise((resolve, reject) => {
    const iframe = createIframe()
    const name = `__download__form__`
    remove(name)

    const form = document.createElement('form')

    form.style.display = 'none'
    // The name of the form. In HTML 4, its use is deprecated (id should be used instead).
    // It must be unique among the forms in a document and not just an empty string in HTML 5.
    form.id = name
    form.name = name
    form.action = url
    form.method = 'post'

    // if (headers && (headers['Content-Type'] || headers['content-type'])) {
    //   form.enctype = headers['Content-Type'] || headers['content-type']
    // }

    /**
     * A name or keyword indicating where to display the response that is received after submitting the form.
     * In HTML 4, this is the name/keyword for a frame.
     * In HTML5, it is a name/keyword for a browsing context (for example, tab, window, or inline frame).
     * The following keywords have special meanings:
     + `_self`: Load the response into the same HTML 4 frame (or HTML5 browsing context) as the current one. This value is the default if the attribute is not specified.
     + `_blank`: Load the response into a new unnamed HTML 4 window or HTML5 browsing context.
     + `_parent`: Load the response into the HTML 4 frameset parent of the current frame, or HTML5 parent browsing context of the current one. If there is no parent, this option behaves the same way as _self.
     + `_top`: HTML 4: Load the response into the full original window, and cancel all other frames. HTML5: Load the response into the top-level browsing context (i.e., the browsing context that is an ancestor of the current one, and has no parent). If there is no parent, this option behaves the same way as _self.
     + `iframename`: The response is displayed in a named <iframe>.
     */
    form.target = iframe.name // iframename

    // if (data) {
    //   let params = data

    /* if (typeof data === 'string' && isJSON(data)) {
        try {
          params = JSON.parse(data)
        } catch (e) {
          console.error(e)
        }
      } */

    // if (typeof params === 'object') {
    //   Object.keys(params).forEach((key) => {
    //     form.appendChild(createInput(key, params[key]))
    //   })
    // } else {
    form.appendChild(createInput('filter', params))
    // }
    // }

    document.body.appendChild(form)
    form.submit()

    remove(form)
  })
}

const createIframe = (config, resolve, reject) => {
  const name = `__download__iframe__`
  remove(name)

  const iframe = document.createElement('iframe')

  iframe.style.display = 'none'
  iframe.id = name
  iframe.name = name
  // iframe.onload = () => {
  //   let json = ''

  //   if (/msie/.test(navigator.userAgent.toLowerCase())) {
  //     json = iframe.contentWindow && iframe.contentWindow.document.body.innerText
  //   } else {
  //     // If the iframe and the iframe's parent document are Same Origin,
  //     // returns a Document (that is, the active document in the inline frame's nested browsing context),
  //     // else returns null.
  //     json = iframe.contentDocument && iframe.contentDocument.body.innerText
  //   }

  //   if (json) {
  //     try {
  //       const data = JSON.parse(json)

  //       if (data && typeof data === 'object') {
  //         reject(createError(data.message, config, '', config, data))
  //       }
  //     } catch (error) {
  //       reject(createError(error, config, '', config, error))
  //     }
  //   } else {
  //     /* 适配 AxiosResponse 数据结构 */
  //     resolve({
  //       data: json,
  //       config,
  //       status: 200,
  //       statusText: 'OK',
  //       headers: null,
  //       request: config,
  //     })
  //   }
  // }

  document.body.appendChild(iframe)

  return iframe
}

const createInput = (key, val) => {
  const input = document.createElement('input')
  input.type = 'hidden'
  input.name = key
  input.value = val && typeof val === 'object' ? JSON.stringify(val) : val

  return input
}

function remove(ele) {
  let $ele = typeof ele === 'string' ? document.getElementById(ele) : ele

  if ($ele && $ele instanceof HTMLElement) {
    $ele.parentNode && $ele.parentNode.removeChild($ele)
    $ele = null
  }
}

export function showError(request) {
  return request.then((response) => {
    if (!response.success) {
      message.error(response.msg)
    }
    return response
  })
}

/**
 * @param {string} urlSearchString
 */
export function searchToObj(urlSearchString) {
  if (urlSearchString.startsWith('?')) {
    urlSearchString = urlSearchString.substring(1)
  }

  const pairs = urlSearchString.split('&')
  const obj = {}
  for (const p of pairs) {
    const kv = p.split('=')
    obj[kv[0]] = kv[1]
  }
  return obj
}
